import createLabelComponent from "../../../../helpers/common/CoreInputText/components/Label/fabric";
import { INPUT_TEXT_DISPLAY_NAME } from "../../utils/core";

export const Component = createLabelComponent(INPUT_TEXT_DISPLAY_NAME);
export default Component;
